import generic_backend_request_post from 'functions/server/generic_backend_request_post';


async function submit_bug_report({user_email='', bug_message='', bug_files=[], bug_filenames=[]}) {
    /**
     * This function sends a POST request to the backend server to submit a bug report.
     * It takes in the user_email, bug_message, bug_files, and bug_filenames and returns the response from the server.
     * 
     * @param {string} user_email - The email of the user reporting the bug.
     * @param {string} bug_message - The message describing the bug.
     * @param {Array} bug_files - An array of files related to the bug.
     * @param {Array} bug_filenames - An array of filenames related to the bug.
     * @returns {Object} - The response from the server.
     */
    const requestJson = {
        // pydantic v2 rejects '' for Optional[EmailStr] — omit when absent.
        ...(user_email ? { user_email } : {}),
        "bug_message": bug_message,
        // The FastAPI model types bug_files as Optional[str] (pydantic v2 —
        // no list coercion), while bug_filenames is a real list. Serialize
        // the array; null when there are no attachments. Flagged to the
        // backend as a probable schema mistake — revert to the raw array if
        // bug_files becomes List[str].
        "bug_files": Array.isArray(bug_files) && bug_files.length > 0 ? JSON.stringify(bug_files) : null,
        "bug_filenames": bug_filenames
    }
    // '/submit_bug_report' was the Flask-era path; died in the December migration.
    const retJson = await generic_backend_request_post(requestJson, '/bug_report');
    return retJson;
}

export default submit_bug_report